import {useEffect} from "react";

/**
 * Reusable Hooks replaces
 * addEventListeners in functional components
 */

export type UseEventArgs = {
    name: string;
    handler: (evt: CustomEvent) => (void | Promise<void>);
    target?: HTMLElement | Window;
    options?: any;
}

export const useEvent = ({
        name,
        handler,
        target = window,
        options
}: UseEventArgs) => {

        useEffect(() => {
            if (!handler) {
                return;
            }
            if (!target) {
                return;
            }
            target.addEventListener(name, handler as EventListener, options);
            // Cleanup
            return () => {
                target.removeEventListener(name, handler as EventListener, options);
            };
        }, [name, handler, target, JSON.stringify(options)]);

};
